import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
const AccessDenied = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h1>403</h1>
      <h2>AccessDenied</h2>
      <Button
        sx={{ bgcolor: '#C09A53', ':hover': { bgcolor: '#9c7c43' } }}
        variant="contained"
        compoment={Link}
        href="/"
      >
        Back to HOME
      </Button>
    </Box>
  );
};
export default AccessDenied;
